import { Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslocoService } from "@jsverse/transloco";
import { ClerkService } from "ngx-clerk-iliad";
import { OrganizationService } from "../../../services/organization.service";
import { UserService } from "../../../services/user.service";
import { AppFullPageLoaderComponent } from "../../../shared/ui/components/full-page-loader/full-page-loader";

@Component({
  selector: "app-sign-out",
  imports: [AppFullPageLoaderComponent],
  template: `<app-full-page-loader [statusText]="statusText"></app-full-page-loader>`,
})
export class AppSignOutPage {
  private readonly _translocoService = inject(TranslocoService);
  private readonly _clerkService = inject(ClerkService);
  private readonly _userService = inject(UserService);
  private readonly _organizationService = inject(OrganizationService);

  public statusText = this._translocoService.translate("app.sign-out.loading");

  constructor() {
    this._userService.clearUser();
    // TODO: Make global "signOut" subject that certain services can listen to for cleanup tasks?

    this._organizationService.clearOrganization();
    this._clerkService.clerk$.pipe(takeUntilDestroyed()).subscribe((x) => x.signOut({ redirectUrl: "/signIn" }));
  }
}
